import React from 'react';

const InputPrimary = ({
                          inputClasses,
                          onFocus,
                          onBlur,
                          onChange,
                          value,
                          name,
                          id,
                          type,
                          placeHolder,
                          dir = 'rtl',
                      }) => {
  return(
      <div className='form-group-input-primary'>
          <label className="form-group-label">
              <input
                  dir={dir}
                  onFocus={onFocus ?? (() => {})}
                  onBlur={onBlur ?? (() => {})}
                  onChange={onChange ?? (() => {})}
                  value={value}
                  name={name ?? ""}
                  id={id ?? ""}
                  type={type ?? ""}
                  placeholder={placeHolder ?? ""}
                  className={`form-group-input ${inputClasses ?? ""}`}
                  autoComplete="off"/>
          </label>
      </div>
  )
}

export default InputPrimary